import { apiFetch } from '../services/api';

/**
 * Save transactions directly via API (bypasses Firestore persist).
 * Stamps locationId and createdBy/createdAt if missing.
 *
 * Transactions are append-only — this utility only creates new records.
 * Updates (like fiscal retry) go through PUT /api/collection directly.
 *
 * @param {Array} txns — array of transaction objects
 * @param {string|number} locationId — active location ID for stamping
 * @param {object} author — { uid, name } for createdBy
 *
 * A failed write is retried once: apiFetch retries only GET, and a sale
 * whose transaction was lost never reaches the reports (audit 2026-11-03).
 * Safe to repeat — the id is fixed, Firestore set and the SQL upsert are
 * idempotent.
 */
export async function saveTransactions(txns, locationId, author) {
  await Promise.all(txns.map(async tx => {
    const stamped = { ...tx };
    if (!stamped.locationId && locationId) stamped.locationId = locationId;
    if (!stamped.createdBy && author) stamped.createdBy = author;
    if (!stamped.createdAt) stamped.createdAt = Date.now();
    const post = () => apiFetch('/api/collection?name=transactions', {
      method: 'POST',
      body: stamped,
    });
    try {
      return await post();
    } catch (err) {
      if (!err?.retryable) throw err;
      await new Promise(r => setTimeout(r, 1000));
      return post();
    }
  }));
}
